import React, { memo } from "react";

import LoadingSpinner from "../../LoadingSpinner";

import { CopyableId } from "./CopyableId";
import { FormatInfo } from "./FormatInfo";
import { ToggleVersions } from "./ToggleVersions";
import { MetaInfoProps } from "./types";
import { VersionInfo } from "./VersionInfo";

import { formatTimestamp } from "@/utils/timestamp";

export const MetaInfo: React.FC<MetaInfoProps> = memo(
  ({
    createdAt,
    additionalInfo,
    id,
    versionInfo,
    format,
    showVersions,
    onToggleVersions,
    isLoading,
  }) => (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
      {createdAt && additionalInfo && (
        <>
          <h4 className="text-sm text-gray-600" title={createdAt}>
            {versionInfo && versionInfo.total > 1 ? "Last Updated: " : "Created: "}
            {formatTimestamp(createdAt)}
          </h4>
          <div className="hidden h-1 w-1 rounded-full bg-gray-300 sm:block" />
          <div className="flex items-center gap-x-1 text-sm text-gray-600">{additionalInfo}</div>
        </>
      )}

      {id !== -1 && <CopyableId id={id} />}
      <VersionInfo versionInfo={versionInfo} />
      <FormatInfo format={format} />
      <ToggleVersions
        showVersions={showVersions}
        onToggleVersions={onToggleVersions}
        versionTotal={versionInfo?.total}
      />
      {isLoading && <LoadingSpinner size={4} />}
    </div>
  ),
);
